import { useRef, useState } from "react";
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "./AcerMobile.css";
import palms1 from "../../../../../assets/palms/cocos-palm.webp";
import palms2 from "../../../../../assets/palms/royal-palm.jpg";
import palms3 from "../../../../../assets/palms/mexican-palm.webp";
import palms4 from "../../../../../assets/palms/robellin.webp";
import palms5 from "../../../../../assets/palms/archontophonix-palm.jpg";
import palmsIcon from "../../../../../assets/palms/palm-animated.jpg";
import Acer from "../../../../../assets/palms/Acer.webp";
import Acer1 from "../../../../../assets/acer/acer1.jpeg";
import Acer2 from "../../../../../assets/acer/acer2.jpeg";
import Acer3 from "../../../../../assets/acer/acer3.jpeg";
import Acer4 from "../../../../../assets/acer/acer4.jpeg";
import Acer5 from "../../../../../assets/acer/acer5.jpeg";
import Acer6 from "../../../../../assets/acer/acer6.jpeg";
import Acer7 from "../../../../../assets/acer/acer7.jpeg";
import Acer8 from "../../../../../assets/acer/acer8.jpeg";
import Acer9 from "../../../../../assets/acer/acer9.jpeg";
import Acer10 from "../../../../../assets/acer/acer10.jpeg";
import Acer11 from "../../../../../assets/acer/acer11.jpeg";
import BackIcon from "../../../../../components/back/back";
const AcerFamilies = [
    {
        id: 6,
        name: "Acer",
        images: [
            { src: Acer4, name: "Acer dissectum ", color: "colored", size: "S" },
            { src: Acer5, name: "Acer dissectum ", color: "colored", size: "M" },
            { src: Acer6, name: "Acer dissectum ", color: "colored", size: "Big" },
            { src: Acer7, name: "Acer dissectum pendula", color: "red", size: "S" },
            { src: Acer8, name: "Acer dissectum pendula", color: "red", size: "Big" },
            { src: Acer9, name: "Acer dissectum pendula", color: "green", size: "S" },
            { src: Acer10, name: "Acer dissectum pendula", color: "green", size: "M" },
            { src: Acer11, name: "Acer palmatum", color: "yellow", size: "M" },
            { src: Acer1, name: "Acer palmatum", color: "green", size: "M" },
            { src: Acer2, name: "Acer palmatum", color: "red", size: "S" },
            { src: Acer3, name: "Acer palmatum", color: "red", size: "M" },

        ],
        description: {
            en: "The Acer tree, commonly known as maple, is admired for its striking foliage, especially during autumn when its leaves display vibrant shades of red, orange, and yellow. It is a popular choice for ornamental landscapes due to its elegant shape and colorful display.",
            ar: "تُعرف شجرة القيقب (Acer) بأوراقها اللافتة، خاصةً في فصل الخريف عندما تتغير ألوان أوراقها إلى درجات زاهية من الأحمر والبرتقالي والأصفر. تُعد خيارًا شائعًا في تنسيق الحدائق لما تتميز به من شكل أنيق وعرض لوني مدهش."
        },
        specifications: {
            en: "- Leaves: Distinct lobed leaves that change colors beautifully in the fall.<br />- Trunk: Straight and sturdy with a grayish bark that may develop ridges as the tree matures.<br />- Size: Depending on species, can range from small shrubs to large trees up to 30 meters (98 feet).<br />- Growth Rate: Moderate to fast, depending on environmental conditions.",
            ar: "- الأوراق: أوراق مفصصة مميزة يتغير لونها بشكل رائع في الخريف.<br />- الجذع: مستقيم وقوي مع لحاء رمادي قد يُظهر تعرجات مع تقدم عمر الشجرة.<br />- الحجم: حسب النوع، يمكن أن تتراوح من شجيرات صغيرة إلى أشجار كبيرة تصل إلى 30 مترًا.<br />- معدل النمو: معتدل إلى سريع حسب ظروف البيئة."
        },
        Maintenance: {
            en: "Minimal pruning is required except to shape or remove dead branches.<br />- Prefers well-drained soil and full to partial sun.<br />- Water during dry periods, especially when newly planted.",
            ar: "لا يتطلب الكثير من التقليم إلا لتشكيلها أو إزالة الفروع الميتة.<br />- تفضل التربة جيدة التصريف وأشعة الشمس الكاملة أو الجزئية.<br />- يجب ريها خلال فترات الجفاف، خاصةً بعد زراعتها حديثًا."
        }
    }
];


export default function AcerCategorieMobile() {
    const [open, setOpen] = useState(false);
    const [selectedPalm, setSelectedPalm] = useState(AcerFamilies.find(p => p.name === "Acer"));
    const [currentIndex, setCurrentIndex] = useState(0);
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const [selectedLanguage, setSelectedLanguage] = useState<"en" | "ar">("en");

    const handleOpen = (palm: any) => {
        setSelectedPalm(palm);
        setCurrentIndex(0);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const scrollToIndex = (index: number) => {
        if (scrollContainerRef.current) {
            const scrollContainer = scrollContainerRef.current;
            const selectedThumbnail = scrollContainer.children[index] as HTMLImageElement;

            if (selectedThumbnail) {
                const scrollAmount = selectedThumbnail.offsetLeft - scrollContainer.offsetLeft - 50;
                scrollContainer.scrollTo({ left: scrollAmount, behavior: "smooth" });
            }
        }
    };

    const nextImage = () => {
        const newIndex = (currentIndex + 1) % (selectedPalm?.images.length || 1);
        setCurrentIndex(newIndex);
        scrollToIndex(newIndex);
    };

    const prevImage = () => {
        const newIndex = (currentIndex - 1 + (selectedPalm?.images.length || 1)) % (selectedPalm?.images.length || 1);
        setCurrentIndex(newIndex);
        scrollToIndex(newIndex);
    };
    const handleTranslate = () => {
        setSelectedLanguage(selectedLanguage === "en" ? "ar" : "en");
    };

    return (
        <div className="palms-container">
            <BackIcon />
            <div className="title-overlay">
                <h1>Acer Collection</h1>
            </div>
            <div className="plants-category-container-mobile grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" >
                {AcerFamilies.map((palms) => (
                    <div key={palms.id} className="palms-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105 cursor-pointer" onClick={() => handleOpen(palms)}>
                        <img src={palms.images[0].src} alt={palms.name} className="w-full h-60 object-cover rounded-lg mb-4" />
                        <p className="plant-name">{palms.name}</p>
                    </div>
                ))}
            </div>

            {/* Popup Dialog */}
            <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
                <DialogTitle>
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }} >
                        <img src={palmsIcon} width={"70px"} height='70px' />
                        <Typography variant="h5" className="gallery-title-name">     {selectedPalm?.name}</Typography>
                    </div>
                    <IconButton onClick={handleClose} style={{ position: "absolute", right: 8, top: 8, backgroundColor: "#AFE1AF" }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div className="horizontal-gallery">
                        <button className="nav-button left" onClick={prevImage}>‹</button>
                        <div className="scroll-container" ref={scrollContainerRef}>
                            {selectedPalm?.images.map((image, index) => (
                                <div className="image-container" key={index}>
                                    <img
                                        src={image.src}
                                        alt={`Gallery ${index}`}
                                        className={`gallery-thumbnail ${currentIndex === index ? "active-thumbnail" : ""}`}
                                        onClick={() => setCurrentIndex(index)}
                                    />
                                    <div style={{ textAlign: "center", marginTop: "8px" }}>
                                        <Typography variant="body2" style={{ fontWeight: "bold" }}>{image.name}</Typography>
                                        <Typography variant="body2" style={{ color: "#40826D" }}>Color: {image.color}</Typography>
                                        <Typography variant="body2" style={{ color: "#FF5F15" }}>Size: {image.size}</Typography>
                                    </div>
                                </div>
                            ))}

                        </div>
                        <button className="nav-button right" onClick={nextImage}>›</button>
                    </div>

                    <div style={{ direction: selectedLanguage === "ar" ? "rtl" : "ltr" }} className="info-container">
                        <p><strong>{selectedLanguage === "ar" ? "الوصف" : "Description"}:</strong><br />
                            <span dangerouslySetInnerHTML={{ __html: selectedPalm?.description[selectedLanguage] || "" }} />
                        </p>
                        <p><strong>{selectedLanguage === "ar" ? "المواصفات" : "Specifications"}:</strong><br />
                            <span dangerouslySetInnerHTML={{ __html: selectedPalm?.specifications[selectedLanguage] || "" }} />
                        </p>
                        <p><strong>{selectedLanguage === "ar" ? 'الصيانة والعناية' : "Maintenance & Care"}:</strong><br />
                            <span dangerouslySetInnerHTML={{ __html: selectedPalm?.Maintenance[selectedLanguage] || "" }} />
                        </p>
                        <Button
                            onClick={handleTranslate}
                            style={{ color: "#40826D", opacity: 0.5, textAlign: selectedLanguage === 'ar' ? 'right' : 'left', fontSize: '12px' }}
                        >
                            Translate
                        </Button>
                    </div>

                </DialogContent>
            </Dialog>
        </div>
    );
}